// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1661":"72e83e56","5737":"72e83e56"}[chunkId] + ".chunk.css";
};